// helpers/safeImageUrl.js
const safeImageUrl = (url = "") =>
  url.startsWith("http://") ? url.replace("http://", "https://") : url;

export default safeImageUrl;
